import { Injectable } from '@angular/core';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { BankDetailsUpdateInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank.details.update.dto';
import type { ContragentCollapseFormInterface } from '@zaoblako/shared/modules/client/dtos/contragent/collapse/contragent-collapse-form.dto';
import type { ContragentDuplicatesPageInterface } from '@zaoblako/shared/modules/client/dtos/contragent/collapse/contragent-duplicates-page.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { ContragentPageQueryInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-page-query.dto';
import type { ContragentPageInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-page.dto';
import type { ContragentQueryInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-query.dto';
import type { ContragentRelatedObjectsStatInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-related-objects-stat.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContragentService extends BaseService {
  protected baseUrl = '/basis/client/contragent';

  public getAll(queryParams: ContragentPageQueryInterface): Observable<ContragentPageInterface> {
    return this.http.get<ContragentPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public search(queryParams?: ContragentQueryInterface): Observable<ContragentFindInterface[]> {
    return this.http.get<ContragentFindInterface[]>(`${this.baseUrl}/list`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public bankDetailsFrom1C(contragentId: number): Observable<BankDetailsUpdateInterface[]> {
    return this.http.get<BankDetailsUpdateInterface[]>(`${this.baseUrl}/${contragentId}/bank-details-from-1c`);
  }

  public getPossibleDuplicates(queryParams: PaginationQueryInterface): Observable<ContragentDuplicatesPageInterface> {
    return this.http.get<ContragentDuplicatesPageInterface>(`${this.baseUrl}/possible-duplicates`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public collapse(id: number, body: ContragentCollapseFormInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/collapse`, body);
  }

  public getHistoryById(contragentId: number, params: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${contragentId}/history`, {
      params: this.objectToHttpParams(params)
    });
  }

  public getRelatedObjectsStat(id: number): Observable<ContragentRelatedObjectsStatInterface> {
    return this.http.get<ContragentRelatedObjectsStatInterface>(`${this.baseUrl}/${id}/related-objects-stat`);
  }
}
